import { getOrganisationRoleSelectOptions } from '@infuse/api/iam/organisation';
import { getAllRoleSelectOptions } from '@infuse/api/iam/role';
import { getTenantRoleSelectOptions } from '@infuse/api/iam/tenant';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { ref } from 'vue';
import { useGenericRoleSelectOptions } from './generic/useGenericRoleSelectOptions';

export const useRoleSelectOptions = () => {
  const { level, user } = useCurrentUserStore();

  const enabled = ref(false);

  if (level === UserLevel.TENANT) {
    return {
      ...useGenericRoleSelectOptions({
        enabled,
        onlyEnableWithParentId: true,
        apiFn: getTenantRoleSelectOptions,
        queryKeys: ['roles', 'selectOptions'],
        fetchParentId: ref(user?.tenantId)
      }),
      enabled
    };
  } else if (level === UserLevel.ORGANISATION) {
    return {
      ...useGenericRoleSelectOptions({
        enabled,
        onlyEnableWithParentId: true,
        apiFn: getOrganisationRoleSelectOptions,
        queryKeys: ['roles', 'selectOptions'],
        fetchParentId: ref(user?.organisationId)
      }),
      enabled
    };
  }

  return {
    ...useGenericRoleSelectOptions({
      enabled,
      onlyEnableWithParentId: false,
      apiFn: getAllRoleSelectOptions,
      queryKeys: ['roles', 'selectOptions']
    }),
    enabled
  };
};
